/* ==========================================================================
   ZONA VET SHOP · NUESTRA FAMILIA V2
   Archivo: assets/zv-family.js
========================================================================== */

(() => {
  'use strict';


  /* ==========================================================================
     INICIALIZAR UNA SECCIÓN
  ========================================================================== */

  function initFamilySlider(section) {
    if (!section) return;

    if (section.dataset.zvFamilyInitialized === 'true') {
      return;
    }

    section.dataset.zvFamilyInitialized = 'true';


    /* ------------------------------------------------------------------------
       ELEMENTOS
    ------------------------------------------------------------------------ */

    const viewport = section.querySelector('[data-zv-family-viewport]');
    const track = section.querySelector('[data-zv-family-track]');
    const slides = Array.from(
      section.querySelectorAll('[data-zv-family-slide]')
    );

    const prevButton = section.querySelector('[data-zv-family-prev]');
    const nextButton = section.querySelector('[data-zv-family-next]');

    const dots = Array.from(
      section.querySelectorAll('[data-zv-family-dot]')
    );

    const currentCounter = section.querySelector(
      '[data-zv-family-current]'
    );


    if (!viewport || !track || slides.length === 0) {
      return;
    }


    /* ------------------------------------------------------------------------
       CONFIGURACIÓN
    ------------------------------------------------------------------------ */

    const loop =
      section.dataset.loop === 'true';

    const autoplay =
      section.dataset.autoplay === 'true';

    const autoplaySpeed =
      Number(section.dataset.autoplaySpeed) || 6000;


    let currentIndex = 0;

    let autoplayTimer = null;

    let resizeFrame = null;

    let pointerStartX = 0;
    let pointerStartY = 0;

    let activeCardObserver = null;


    /* ==========================================================================
       ALTURA ADAPTATIVA
    ========================================================================== */

    function getActiveCard() {
      const activeSlide = slides[currentIndex];

      if (!activeSlide) return null;

      return activeSlide.querySelector(
        '.zv-family-v2__card'
      );
    }


    function updateSliderHeight(immediate = false) {
      const activeCard = getActiveCard();

      if (!activeCard) return;


      requestAnimationFrame(() => {
        const height =
          Math.ceil(
            activeCard.getBoundingClientRect().height
          );

        if (!height) return;


        if (immediate) {
          const previousTransition =
            viewport.style.transition;

          viewport.style.transition = 'none';

          viewport.style.height = `${height}px`;

          viewport.offsetHeight;

          viewport.style.transition =
            previousTransition;
        } else {
          viewport.style.height = `${height}px`;
        }
      });
    }


    function observeActiveCard() {
      if (activeCardObserver) {
        activeCardObserver.disconnect();
      }

      if (!('ResizeObserver' in window)) {
        return;
      }

      const activeCard = getActiveCard();

      if (!activeCard) return;


      activeCardObserver =
        new ResizeObserver(() => {
          updateSliderHeight();
        });

      activeCardObserver.observe(activeCard);
    }


    /* ==========================================================================
       NORMALIZAR ÍNDICE
    ========================================================================== */

    function normalizeIndex(index) {
      if (loop) {

        if (index < 0) {
          return slides.length - 1;
        }

        if (index >= slides.length) {
          return 0;
        }

        return index;
      }


      return Math.max(
        0,
        Math.min(index, slides.length - 1)
      );
    }


    /* ==========================================================================
       ACTUALIZAR ESTADOS VISUALES
    ========================================================================== */

    function updateSlides() {
      slides.forEach((slide, index) => {
        const isActive =
          index === currentIndex;

        slide.classList.toggle(
          'is-active',
          isActive
        );

        slide.setAttribute(
          'aria-hidden',
          isActive ? 'false' : 'true'
        );
      });
    }


    function updateDots() {
      dots.forEach((dot, index) => {
        const isActive =
          index === currentIndex;

        dot.classList.toggle(
          'is-active',
          isActive
        );

        dot.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );
      });
    }


    function updateCounter() {
      if (!currentCounter) return;

      currentCounter.textContent =
        String(currentIndex + 1);
    }


    function updateArrows() {
      if (loop) {

        if (prevButton) {
          prevButton.disabled = false;
        }

        if (nextButton) {
          nextButton.disabled = false;
        }

        return;
      }


      if (prevButton) {
        prevButton.disabled =
          currentIndex === 0;
      }

      if (nextButton) {
        nextButton.disabled =
          currentIndex === slides.length - 1;
      }
    }


    /* ==========================================================================
       MOVER CARRUSEL
    ========================================================================== */

    function updateTrack() {
      track.style.transform =
        `translate3d(-${currentIndex * 100}%, 0, 0)`;
    }


    function goToSlide(index, options = {}) {
      const {
        restartAutoplay = true
      } = options;


      currentIndex =
        normalizeIndex(index);


      updateTrack();
      updateSlides();
      updateDots();
      updateCounter();
      updateArrows();

      observeActiveCard();

      updateSliderHeight();


      if (restartAutoplay) {
        restartAutoplayTimer();
      }
    }


    /* ==========================================================================
       AUTOPLAY
    ========================================================================== */

    function stopAutoplay() {
      if (!autoplayTimer) return;

      clearInterval(autoplayTimer);

      autoplayTimer = null;
    }


    function startAutoplay() {
      if (!autoplay) return;

      if (slides.length < 2) return;

      stopAutoplay();


      autoplayTimer =
        window.setInterval(() => {

          if (!loop &&
              currentIndex === slides.length - 1) {

            goToSlide(0, {
              restartAutoplay: false
            });

            return;
          }


          goToSlide(
            currentIndex + 1,
            {
              restartAutoplay: false
            }
          );

        }, autoplaySpeed);
    }


    function restartAutoplayTimer() {
      if (!autoplay) return;

      startAutoplay();
    }


    /* ==========================================================================
       FLECHAS
    ========================================================================== */

    if (prevButton) {

      prevButton.addEventListener(
        'click',
        () => {
          goToSlide(currentIndex - 1);
        }
      );

    }


    if (nextButton) {

      nextButton.addEventListener(
        'click',
        () => {
          goToSlide(currentIndex + 1);
        }
      );

    }


    /* ==========================================================================
       DOTS
    ========================================================================== */

    dots.forEach((dot) => {

      dot.addEventListener(
        'click',
        () => {

          const index =
            Number(dot.dataset.slideIndex);

          if (
            Number.isNaN(index) ||
            index === currentIndex
          ) {
            return;
          }

          goToSlide(index);

        }
      );

    });


    /* ==========================================================================
       SWIPE / POINTER
    ========================================================================== */

    viewport.addEventListener(
      'pointerdown',
      (event) => {

        pointerStartX = event.clientX;
        pointerStartY = event.clientY;

      }
    );


    viewport.addEventListener(
      'pointerup',
      (event) => {

        const differenceX =
          event.clientX - pointerStartX;

        const differenceY =
          event.clientY - pointerStartY;


        if (
          Math.abs(differenceX) < 45 ||
          Math.abs(differenceX) <= Math.abs(differenceY)
        ) {
          return;
        }


        if (differenceX < 0) {
          goToSlide(currentIndex + 1);
        } else {
          goToSlide(currentIndex - 1);
        }

      }
    );


    /* ==========================================================================
       PAUSAR AUTOPLAY AL INTERACTUAR
    ========================================================================== */

    section.addEventListener(
      'mouseenter',
      stopAutoplay
    );


    section.addEventListener(
      'mouseleave',
      startAutoplay
    );


    section.addEventListener(
      'focusin',
      stopAutoplay
    );


    section.addEventListener(
      'focusout',
      (event) => {

        if (
          section.contains(
            event.relatedTarget
          )
        ) {
          return;
        }

        startAutoplay();

      }
    );


    /* ==========================================================================
       DRAWERS
    ========================================================================== */

    const openButtons =
      Array.from(
        section.querySelectorAll(
          '[data-zv-family-open]'
        )
      );

    const drawers =
      Array.from(
        section.querySelectorAll(
          '[data-zv-family-drawer]'
        )
      );


    let activeDrawer = null;
    let activeTrigger = null;


    function openDrawer(button) {
      const drawerId =
        button.dataset.drawerId;

      if (!drawerId) return;


      const drawer =
        section.querySelector(
          `#${CSS.escape(drawerId)}`
        );

      if (!drawer) return;


      closeDrawer(false);


      activeDrawer = drawer;
      activeTrigger = button;


      drawer.classList.add('is-open');

      drawer.setAttribute(
        'aria-hidden',
        'false'
      );

      button.setAttribute(
        'aria-expanded',
        'true'
      );


      document.body.classList.add(
        'zv-family-v2-lock'
      );


      const closeButton =
        drawer.querySelector(
          '.zv-family-v2__drawer-close'
        );


      if (closeButton) {
        requestAnimationFrame(() => {
          closeButton.focus();
        });
      }
    }


    function closeDrawer(restoreFocus = true) {
      if (!activeDrawer) return;


      activeDrawer.classList.remove(
        'is-open'
      );

      activeDrawer.setAttribute(
        'aria-hidden',
        'true'
      );


      if (activeTrigger) {

        activeTrigger.setAttribute(
          'aria-expanded',
          'false'
        );

      }


      document.body.classList.remove(
        'zv-family-v2-lock'
      );


      if (
        restoreFocus &&
        activeTrigger
      ) {
        activeTrigger.focus();
      }


      activeDrawer = null;
      activeTrigger = null;
    }


    openButtons.forEach((button) => {

      button.addEventListener(
        'click',
        () => {
          openDrawer(button);
        }
      );

    });


    drawers.forEach((drawer) => {

      const closeButtons =
        drawer.querySelectorAll(
          '[data-zv-family-close]'
        );


      closeButtons.forEach((button) => {

        button.addEventListener(
          'click',
          () => {
            closeDrawer();
          }
        );

      });

    });


    /* ==========================================================================
       ESCAPE
    ========================================================================== */

    document.addEventListener(
      'keydown',
      (event) => {

        if (
          event.key === 'Escape' &&
          activeDrawer
        ) {
          closeDrawer();
        }

      }
    );


    /* ==========================================================================
       RESIZE
    ========================================================================== */

    function handleResize() {
      if (resizeFrame) {
        cancelAnimationFrame(resizeFrame);
      }


      resizeFrame =
        requestAnimationFrame(() => {

          updateSliderHeight(true);

          resizeFrame = null;

        });
    }


    window.addEventListener(
      'resize',
      handleResize,
      { passive: true }
    );


    /* ==========================================================================
       IMÁGENES
    ========================================================================== */

    section
      .querySelectorAll('img')
      .forEach((image) => {

        if (image.complete) {
          return;
        }


        image.addEventListener(
          'load',
          () => {
            updateSliderHeight(true);
          },
          {
            once: true
          }
        );

      });


    /* ==========================================================================
       FUENTES
    ========================================================================== */

    if (document.fonts && document.fonts.ready) {

      document.fonts.ready.then(() => {
        updateSliderHeight(true);
      });

    }


    /* ==========================================================================
       ESTADO INICIAL
    ========================================================================== */

    updateTrack();
    updateSlides();
    updateDots();
    updateCounter();
    updateArrows();

    observeActiveCard();

    updateSliderHeight(true);

    startAutoplay();
  }


  /* ==========================================================================
     INICIALIZAR TODAS
  ========================================================================== */

  function initAllFamilySliders(root = document) {
    const sections = [];


    if (
      root.matches &&
      root.matches('[data-zv-family-slider]')
    ) {
      sections.push(root);
    }


    if (root.querySelectorAll) {

      root
        .querySelectorAll(
          '[data-zv-family-slider]'
        )
        .forEach((section) => {
          sections.push(section);
        });

    }


    sections.forEach(
      initFamilySlider
    );
  }


  /* ==========================================================================
     CARGA NORMAL
  ========================================================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAllFamilySliders();
      }
    );

  } else {

    initAllFamilySliders();

  }


  /* ==========================================================================
     SHOPIFY THEME EDITOR
  ========================================================================== */

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAllFamilySliders(event.target);
    }
  );

})();